import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  Typography,
  CardContent,
  Alert,
  AlertTitle,
  Button,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import { mkConfig, generateCsv, download } from "export-to-csv";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";

import { MaterialReactTable } from "material-react-table";

import Header from "./header";

import { apiData } from "../services/api-methods";

import API from "../APIUrls";
import PageDropdown from "./pageDD";
import FullPageLoader from "./loader";
import Footer from "./footer";

function EnquiryList() {
  const navigate = useNavigate();
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const [rowCount, setRowCount] = useState(0);
  const [tblList, setTblList] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  async function fetchData() {
    try {
      setLoading(true);
      let tempData = await apiData("get", API.enquiry, {
        pagination: JSON.stringify(pagination),
        filters: JSON.stringify(columnFilters),
      });
      setTblList(tempData.data);
      setRowCount(tempData.pagination.totalCount);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, [globalFilter, pagination, columnFilters]);

  const columns = useMemo(() => {
    const columns = [
      {
        accessorKey: "name",
        header: "Name",
        Cell: ({ cell, row }) => row.original.name,
      },
      {
        accessorKey: "email",
        header: "Email",
        Cell: ({ cell, row }) => row.original.email,
      },
      {
        accessorKey: "contactNo",
        header: "Mobile Number",
        Cell: ({ cell, row }) => row.original.contactNo,
      },

      {
        header: "Property Name",
        Cell: ({ cell, row }) =>
          row.original.property ? row.original.property.name : "-",
      },
      {
        header: "Property Address",
        Cell: ({ cell, row }) => {
          const propertyId = row.original.property
            ? row.original.property._id
            : null;
          return propertyId ? (
            <div
              style={{ cursor: "pointer", color: "blue" }}
              onClick={() => navigate(`/property/add/${propertyId}`)}
            >
              {row.original.property.address}
            </div>
          ) : (
            <span>-</span>
          );
        },
      },
      {
        header: "Coupon Code",
        Cell: ({ cell, row }) =>
          row.original.property ? row.original.property.coupon : "-",
      },
      {
        header: "Delete",
        Cell: ({ cell, row }) => {
          return (
            <div style={{ color: "#E1341E", cursor: "pointer" }}>
              <DeleteIcon onClick={() => handleDelete(row.original._id)} />
            </div>
          );
        },
      },
    ];

    return columns;
  }, []);

  const handleDelete = async (id) => {
    const confirm = window.confirm(
      "This action can't be revert. Are you sure you want to delete ?"
    );

    if (confirm) {
      let tempData = await apiData("delete", API.enquiry, { id: id });

      setMessage({
        msg: tempData.msg,
        status: tempData.statusCode === 200 ? "success" : "error",
      });

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const handleExportData = async () => {
    try {
      setLoading(true);
      let tempData = await apiData("get", API.enquiry, {
        filters: JSON.stringify(columnFilters),
      });

      if (tempData?.statusCode === 200 || tempData?.statusCode === "200") {
        const newData =
          tempData.data &&
          tempData.data.map((row) => {
            console.log(row);
            const updatedRow = {
              Name: row.name ? row.name : "-",
              Email: row.email ? row.email : "-",
              "Contact Number": row.contactNo ? row.contactNo : "-",
              Address: row.address ? row.address : "-",
              "Property Name": row.property?.name ?? "-",
              "Property Address": row.property?.address ?? "-",
              Coupon: row.property?.coupon ?? "-",
              "Created At":
                moment(row.created_at).format("DD/MM/YYYY hh:mm A") || "-",
            };
            return updatedRow;
          });

        const csvConfig = mkConfig({
          fieldSeparator: ",",
          decimalSeparator: ".",
          useKeysAsHeaders: true,
        });

        const csv = generateCsv(csvConfig)(newData);

        download({
          ...csvConfig,
          filename: `Leads.csv`,
        })(csv);
      }
    } catch (error) {
      console.error("Error during export:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <FullPageLoader />;
  }

  return (
    <div className="main">
      <Header />
      {message && message.status && (
        <Alert severity={`${message.status}`} style={{ margin: "2% 10% 0%" }}>
          <AlertTitle>{message.status}</AlertTitle>
          {message.msg && <>{message.msg}</>}
        </Alert>
      )}
      <Grid className="employee-form">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Enquiries List
            </Typography>
          </Grid>
          <PageDropdown page="enquiry" />
        </Grid>
        <CardContent className="tableCOntent" sx={{ pt: 0 }}>
          <MaterialReactTable
            columns={columns}
            data={tblList}
            // enableRowSelection
            getRowId={(row) => row.name}
            enableColumnFilterModes
            initialState={{ showColumnFilters: false }}
            enableRowNumbers
            rowNumberMode="original"
            manualFiltering
            manualPagination
            manualSorting
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              globalFilter,
              // isLoading,
              pagination,
              // showAlertBanner: isError,
              // showProgressBars: isRefetching,
              sorting,
            }}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <Button onClick={() => handleExportData()} color={"success"}>
                  Export Data
                </Button>
              </Box>
            )}
          />
        </CardContent>
      </Grid>
      <Footer />
    </div>
  );
}

export default EnquiryList;
